import { TimelineParty } from '../../timeline/models/enums/timeline-party.enum';

export enum ClosingDateProposalStatus {
    Pending = 1,
    Accepted = 2,
    Declined = 3,
    Superseded = 4,
}

export enum ClosingDateResponseStatus {
    Pending = 1,
    Accepted = 2,
    Declined = 3,
}

export interface ClosingDateResponse {
    party: TimelineParty;
    status: ClosingDateResponseStatus;
    comment?: string | null;
    respondedByUserId?: number | null;
    respondedAt?: string | null;
}

export interface ClosingDateCloseConfirmation {
    party: TimelineParty;
    isConfirmed: boolean;
    confirmedByUserId?: number | null;
    confirmedAt?: string | null;
}

export interface ClosingDateProposal {
    id: string;
    proposedDate: string;
    proposedByParty: TimelineParty;
    proposedByUserId: number;
    proposedByName: string;
    comment: string;
    proposedAt: string;
    status: ClosingDateProposalStatus;
    responses: ClosingDateResponse[];
}

export interface EngagementClosingDate {
    engagementId: number;
    defaultClosingDate?: string | null;
    officialClosingDate?: string | null;
    agreedClosingDate?: string | null;
    earliestClosingDate?: string | null;
    earliestClosingDateStepName?: string | null;
    flowOfFundsRecommendedClosingDate?: string | null;
    timelineNoLongerFits: boolean;
    closingDateHeldByStepName?: string | null;
    currentProposal?: ClosingDateProposal | null;
    closeConfirmations: ClosingDateCloseConfirmation[];
    hasUnresolvedFlowOfFundsItems: boolean;
    isEngagementClosed: boolean;
    threadedDiscussionId?: number | null;
    commsId?: number | null;
    currentUserParty?: TimelineParty | null;
    canPropose: boolean;
    canRespond: boolean;
    canConfirmClose: boolean;
    hasClosingDateArrived: boolean;
}
